function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg103Burundi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.006 512.006",
    style: {
      enableBackground: "new 0 0 512.006 512.006"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 0.017,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "215.866,256.008 0.003,471.864 0.003,40.136  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "512.003,40.136 512.003,471.864 296.139,256.008  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "512.003,40.136 296.139,256.008 512.003,471.864 512.003,512 471.878,512 256.003,296.127   40.128,512 0.003,512 0.003,471.864 215.866,256.008 0.003,40.136 0.003,0 40.128,0 256.003,215.873 471.878,0 512.003,0 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "512.003,40.136 296.139,256.008 512.003,471.864 512.003,512 471.878,512 256.003,296.127    40.128,512 0.003,512 0.003,471.864 215.866,256.008 0.003,40.136 0.003,0 40.128,0 256.003,215.873 471.878,0 512.003,0  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256.003,
    cy: 256,
    r: 74.207
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "256.003,204.058 262.428,215.188 275.281,215.188 268.855,226.318 275.281,237.449    262.428,237.449 256.003,248.579 249.577,237.449 236.725,237.449 243.15,226.318 236.725,215.188 249.577,215.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "223.339,256 229.765,267.13 242.617,267.13 236.192,278.261 242.617,289.391    229.765,289.391 223.339,300.522 216.913,289.391 204.06,289.391 210.487,278.261 204.06,267.13 216.913,267.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "288.666,256 295.093,267.13 307.945,267.13 301.518,278.261 307.945,289.391    295.093,289.391 288.666,300.522 282.241,289.391 269.388,289.391 275.814,278.261 269.388,267.13 282.241,267.13  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg103Burundi);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };